<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Indoor Air Quality</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (airFilterSelection) {
          <span>
            <label class="halfWidthInputLabel">Air Filter:</label>
            <select class="halfWidthInputField" #airFilterInput
              [class.invalidConfigurationSelection]="isInvalidSelection(airFilterSelection.Name)"
              (change)="selectedValueChanged(airFilterSelection.Name, airFilterInput.value)"
              [value]="airFilterSelection.Value.toString()">
              @for (allowable of airFilterSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="airFilterSelection.Value && airFilterSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (airPurificationSelection) {
          <span>
            <label class="halfWidthInputLabel">Air Purification:</label>
            <select class="halfWidthInputField" #airPurificationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(airPurificationSelection.Name)"
              (change)="selectedValueChanged(airPurificationSelection.Name, airPurificationInput.value)"
              [value]="airPurificationSelection.Value.toString()">
              @for (allowable of airPurificationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="airPurificationSelection.Value && airPurificationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
